export default __webpack_public_path__ + "static/media/moon-light.78583c11.svg";